import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import ReactSelectField from 'dashboard/components/FormControls/ReactSelectField';
import Form from 'dashboard/layouts/FormLayout/Form';
import { Role } from 'dashboard/models/role';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import { isRequired, withMessage } from 'lib/utils/formValidation';

interface FormUpdateRolesProps {
  allRoles: Role[];
}

const validate = {
  roleValue: [withMessage('Please select at least one role', isRequired)],
};

const FormUpdateRoles = ({
  handleSubmit,
  submitting,
  allRoles,
}: FormUpdateRolesProps & InjectedFormProps<FormUpdateRolesData, FormUpdateRolesProps>) => {
  const options = allRoles.map((role) => {
    return { label: role.attributes.name, value: role.id };
  });

  return (
    <Form onSubmit={handleSubmit}>
      <Field
        component={ReactSelectField}
        name='roleIds'
        id='form-update-roles__roles-select'
        data-test='form-update-roles__roles-select'
        disabled={submitting}
        validate={validate.roleValue}
        options={options}
        portal={true}
        isMulti
      />
      <HStack>
        <Button
          type='submit'
          value='Submit'
          data-test='form-update-roles__submit'
          name='update-roles.submit'
        >
          Update Roles
        </Button>
      </HStack>
    </Form>
  );
};

export interface FormUpdateRolesData {
  roleIds: string[];
}

export default reduxForm<FormUpdateRolesData, FormUpdateRolesProps>({
  form: 'updateRoles',
  // these updates the form's initial state when you save so the next time you open the modal the values are correct
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(FormUpdateRoles);
